import React from 'react';
import { usePaginationFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';
import { EmptyStateList, InfiniteScrollV2 } from 'embeds/components';
import { compact, get, isEmpty, map } from 'lodash';

import { ListFacilities_EmbedQuery$key } from './__generated__/ListFacilities_EmbedQuery.graphql';
import ListItemFacility from './ListItemFacility';
import ListNodes, { ListNodesProps } from './ListNodes';

export interface ListFacilitiesProps extends ListNodesProps {
  fragmentRef: ListFacilities_EmbedQuery$key;
  disabled?: boolean;
}

const ListFacilities: React.FC<ListFacilitiesProps> = ({ fragmentRef, disabled = false, ...rest }) => {
  const {
    data: { facilityConnection },
    loadNext,
    isLoadingNext,
    hasNext,
  } = usePaginationFragment<any, ListFacilities_EmbedQuery$key>(
    graphql`
      fragment ListFacilities_EmbedQuery on Query
        @argumentDefinitions(
          cursor: { type: "String" }
          count: { type: "Int", defaultValue: 15 }
          regex: { type: "String" }
        )
        @refetchable(queryName: "ListFacilities_Embed_refetchable") {
        facilityConnection(
          first: $count
          sort: NAME_ASC
          after: $cursor
          filter: { visible: true, _operators: { name: { regex: $regex } } }
        ) @connection(key: "ListFacilities_facilityConnection") {
          edges {
            node {
              _id
              ...ListItemFacility_EmbedNode
            }
          }
        }
      }
    `,
    fragmentRef,
  );
  const facilities = compact(map(get(facilityConnection, 'edges'), 'node'));

  return (
    <InfiniteScrollV2 hasNext={hasNext} isLoadingNext={isLoadingNext} loadNext={() => loadNext(15)}>
      <ListNodes {...rest}>
        {isEmpty(facilities) ? (
          <EmptyStateList />
        ) : (
          map(facilities, (facility) => (
            <ListItemFacility key={facility._id} disabled={disabled} fragmentRef={facility} />
          ))
        )}
      </ListNodes>
    </InfiniteScrollV2>
  );
};

export default ListFacilities;
